import './App.css';
import SudokuInputBox from './Components/SudokuInputBox';

function App() {
  return (
    <div className="App">
      <SudokuInputBox />
    </div>
  );
}

export default App;
